import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output, QueryList, SimpleChanges, ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, LazyLoadEvent, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {TableButtonConfig} from "../../model/api/table-button-config";
import {ExportAsService} from "ngx-export-as";
import {DatePipe, DecimalPipe} from "@angular/common";
import {AppComponent} from "../../app.component";
import {CctableBaseComponent} from "../table/cc-table-base.component";
import {TableEditColumnConfig} from "../../model/api/table-edit-column-config";
import {CcSubFormBaseComponent} from "../form-dialog/form/cc-sub-form-base.component";

@Component({
  selector: 'app-cc-table-edit',
  templateUrl: './cc-table-edit.component.html',
  styleUrls: ['./cc-table-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CcTableEditComponent extends CctableBaseComponent {

  @Output()
  recordChange = new EventEmitter<any>();

  @Input()
  tableConfig: TableEditColumnConfig[] = [];

  @Input()
  headerButtonConfig: TableButtonConfig[] = [];

  @Input()
  footerButtonConfig: TableButtonConfig[] = [];

  // @Input()
  // contextMenuConfig: MenuItem[];
  // @Output()
  // onContextMenuShow = new EventEmitter<any>();

  @Input()
  selectedRecord: any;
  @Output()
  selectedRecordChange = new EventEmitter<any>();

  @Input()
  selectedRecords: any[];
  @Output()
  selectedRecordsChange = new EventEmitter<any>();

  @Input()
  selectionMode: string = 'none';

  @Input()
  defaultSortOrder: number = 1;

  // @Input()
  // lazyLoadOnInit: boolean = true;

  @Input()
  reorderableRows: boolean = false;

  @Output()
  rowOrderChanged = new EventEmitter<any>();

  // @Input()
  // globalFilterFields: string[] = undefined;

  // @Input()
  // isLazy: boolean = true;

  complexFilterMode: boolean = false;

  lastRecordsIndexClicked: number = -1;
  lastShiftRecordsIndexClicked: number = -1;

  mouseDown: boolean = false;
  lastMouseSelect: boolean = false;
  filterVisible: boolean;

  tableValueMap = {};

  @ViewChildren('ccSubForm')
  subFormComponents: QueryList<CcSubFormBaseComponent>;

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              exportAsService: ExportAsService) {
    super(el, cdref, messageService, translateService, exportAsService);

  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.reloadTableValueMap();
  }

  protected postInitConfigs() {
    super.postInitConfigs();
    this.tableConfig.forEach(columnConfig => {
      if (!columnConfig.filterConfig) {
        columnConfig.filterConfig = {
          type: 'text',
          matchMode: 'contains'
        };
      }
    });
    // this.reloadTableValueMap();
    // setTimeout(() => {
    //   this.reloadTableValueMap();
    // });

  }

  onRowDblClick_(record: any) {
    this.onRowDblClick.emit(record);
  }

  // ctrlKeyDown: boolean = false;
  //
  // @HostListener('document:keydown.control', ['$event'])
  // handleCtrlKeyboardDownEvent(event: KeyboardEvent) {
  //   this.ctrlKeyDown = true;
  // }
  //
  // @HostListener('document:keyup.control', ['$event'])
  // handleCtrlKeyboardUpEvent(event: KeyboardEvent) {
  //   this.ctrlKeyDown = false;
  // }
  onRowRightClick_(record: any) {
    this.onRowRightClick.emit(record);
  }

  @HostListener('document:keydown.control.a', ['$event'])
  onSelectAll(e: KeyboardEvent) {
    if (this.disableSelection) return;
    if (!this.focused) return;
    // if (this.el.nativeElement.contains(e.target)) {
    this.selectedRecords = [...this.ccTable.processedData];
    this.ccTable.processedData.filter(value => value && !value.selected).forEach(record => record.selected = true);
    this.selectedRecordsChange.emit(this.selectedRecords);
    this.reloadTableValueMap();
    // }
  }

  filterShows() {
    console.log("-------> filterShows");
  }

  filterHides() {
    console.log("-------> filterHides");
  }

  selectKeyUp($event: KeyboardEvent) {
    if (this.lastRecordsIndexClicked == -1) {
      this.lastRecordsIndexClicked = this.focusedRowIndex;
      // if (this.selectedRecords.length > 0)
      //   this.lastRecordsIndexClicked = this.records.indexOf(this.selectedRecords[0]);
      // else this.lastRecordsIndexClicked = 0;
    }
    if (this.lastRecordsIndexClicked > 0) {
      this.lastRecordsIndexClicked--;
      const record = this.records[this.lastRecordsIndexClicked];
      this.doSelect(record, this.lastRecordsIndexClicked, $event.shiftKey, $event.ctrlKey);
      this.lastMouseSelect = this.selectedRecords.includes(record);
      $event.preventDefault();
      const tableId = this.el.nativeElement.querySelectorAll("table").item(0).id;
      try {
        const elm = document.querySelectorAll('#' + tableId + ' #' + record[this.fieldId]);
        if (elm && elm.length > 0)
          elm[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: "nearest"});
      } catch (e) {
      }
    }
  }

  selectKeyDown($event: KeyboardEvent) {
    if (this.lastRecordsIndexClicked == -1) {
      this.lastRecordsIndexClicked = this.focusedRowIndex;
      // if (this.selectedRecords.length > 0)
      //   this.lastRecordsIndexClicked = this.records.indexOf(this.selectedRecords[this.selectedRecords.length - 1]);
      // else this.lastRecordsIndexClicked = 0;
    }
    if (this.lastRecordsIndexClicked < this.records.length - 1) {
      this.lastRecordsIndexClicked++;
      const record = this.records[this.lastRecordsIndexClicked];
      this.doSelect(record, this.lastRecordsIndexClicked, $event.shiftKey, $event.ctrlKey);
      this.lastMouseSelect = this.selectedRecords.includes(record);
      $event.preventDefault();
      const tableId = this.el.nativeElement.querySelectorAll("table").item(0).id;

      try {
        const elm = document.querySelectorAll('#' + tableId + ' #' + record[this.fieldId]);
        if (elm && elm.length > 0)
          elm[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: "nearest"});
      } catch (e) {
      }
    }
  }


  onRowMouseUp(record: any, clickedRecordsIndex: number, $event: MouseEvent) {
    if (this.disableSelection) return;
    if (this.mouseDown && $event.button == 0 && this.lastMouseSelect) {
      this.lastShiftRecordsIndexClicked = this.lastRecordsIndexClicked;
      clickedRecordsIndex = this.ccTable.processedData.findIndex(value => value == record);
      this.doSelect(record, clickedRecordsIndex, true, false);
    }
  }

  onRowMouseDown(record: any, clickedRecordsIndex: number, $event: MouseEvent) {
    if (this.disableSelection) return;
    if (this.tableContextMn != null)
      this.tableContextMn.hide();
    if (!this.mouseDown && ($event.button == 0
      || ($event.button == 2 && this.selectedRecords && !this.selectedRecords.includes(record)))) {
      clickedRecordsIndex = this.ccTable.processedData.findIndex(value => value == record);
      this.doSelect(record, clickedRecordsIndex, $event.shiftKey, $event.ctrlKey);
      this.lastMouseSelect = this.selectedRecords ? this.selectedRecords.includes(record) : false;
    }
  }

  doSelect(clickedRecord: any, clickedRecordsIndex: number
    , shiftPressed: boolean, ctrlPressed: boolean) {
    if('none' === this.selectionMode ) return;
    if (this.disableSelection) return;
    if (!this.selectedRecords) this.selectedRecords = [];
    if (!ctrlPressed && ('single' === this.selectionMode || !shiftPressed && this.selectedRecords.length > 0)) {
      this.clearSelection();
    }
    const clickedSelectedIndex = this.selectedRecords.indexOf(clickedRecord);
    if (clickedSelectedIndex != -1 && !shiftPressed) {
      clickedRecord.selected = false;
      this.selectedRecords.splice(clickedSelectedIndex, 1);
    } else {
      if (clickedSelectedIndex == -1) {
        const record = this.ccTable.processedData[clickedRecordsIndex];
        if (record) record.selected = true;
        this.selectedRecords.push(clickedRecord);
      }
      if ('multiple' === this.selectionMode
        && shiftPressed && this.lastRecordsIndexClicked !== -1) {
        if (this.lastShiftRecordsIndexClicked !== -1 &&
          ((clickedRecordsIndex < this.lastRecordsIndexClicked && this.lastShiftRecordsIndexClicked > this.lastRecordsIndexClicked)
            || (clickedRecordsIndex > this.lastRecordsIndexClicked && this.lastShiftRecordsIndexClicked < this.lastRecordsIndexClicked))) {
          const firstIndex = this.lastShiftRecordsIndexClicked < this.lastRecordsIndexClicked ?
            this.lastShiftRecordsIndexClicked : this.lastRecordsIndexClicked;
          const lastIndex = this.lastShiftRecordsIndexClicked < this.lastRecordsIndexClicked ?
            this.lastRecordsIndexClicked : this.lastShiftRecordsIndexClicked;
          for (let i = firstIndex; i <= lastIndex; i++) {
            const record = this.ccTable.processedData[i];
            const selectedIndex = this.selectedRecords.indexOf(record);
            if (selectedIndex != -1) {
              record.selected = false;
              this.selectedRecords.splice(selectedIndex, 1);
            }
          }
        }
        const firstIndex = clickedRecordsIndex < this.lastRecordsIndexClicked ? clickedRecordsIndex : this.lastRecordsIndexClicked;
        const lastIndex = clickedRecordsIndex < this.lastRecordsIndexClicked ? this.lastRecordsIndexClicked : clickedRecordsIndex;
        for (let i = firstIndex; i <= lastIndex; i++) {
          const record = this.ccTable.processedData[i];
          if (record && this.selectedRecords.indexOf(record) == -1) {
            this.selectedRecords.push(record);
            record.selected = true;
          }
        }
        this.lastShiftRecordsIndexClicked = clickedRecordsIndex;
      }
    }
    if (!shiftPressed || this.lastRecordsIndexClicked === -1) {
      this.lastRecordsIndexClicked = clickedRecordsIndex;
      this.lastShiftRecordsIndexClicked = -1;
    }
    this.selectedRecords = [...this.selectedRecords];
    this.selectedRecordsChange.emit(this.selectedRecords);
    setTimeout(() => {
      this.reloadTableValueMap();
    })
  }

  private clearSelection() {
    this.records.filter(value => value && value.selected).forEach(record => record.selected = false);
    this.selectedRecords = [];
    this.selectedRecords = [...this.selectedRecords];
    this.selectedRecordsChange.emit(this.selectedRecords);
    this.lastRecordsIndexClicked = -1;
    this.lastShiftRecordsIndexClicked = -1;
    this.lastMouseSelect = false;
    this.reloadTableValueMap();
  }

  loadRecords(event: LazyLoadEvent) {
    super.loadRecords(event);
    // this.clearSelection();
  }

  onFilterChange() {
    this.reloadTableValueMap();
    this.filterChangedEvent.emit();
  }

  onSortChange() {
    this.reloadTableValueMap();
    // setTimeout(() => this.reloadTableValueMap());
    this.sortChangedEvent.emit();
  }


  public reloadTableValueMap() {
    // console.log('-----> reloadTableValueMap')
    this.tableValueMap['hasFilter'] = this.hasFilter();
    this.tableValueMap['hasSort'] = this.hasSort();
    this.headerButtonConfig.forEach((conf, index) => {
      if (conf.enabled) this.tableValueMap['bttHeaderEnabled-' + index] = conf.enabled()
    });
    this.footerButtonConfig.forEach((conf, index) => {
      if (conf.enabled) this.tableValueMap['bttFooterEnabled-' + index] = conf.enabled()
    });
    this.tableConfig.forEach((conf, index) => {
      if (!conf.hidden && this.ccTable && this.ccTable.processedData) {
        this.ccTable.processedData.forEach((record, recordIndex) => {
          const trueRecordIndex = recordIndex + this.ccTable.first;
          if (record) {
            if (conf.style)
              this.tableValueMap['style-' + index + '_' + trueRecordIndex] = conf.style(record);
            if (conf.mapId)
              this.tableValueMap['mapId-' + index + '_' + trueRecordIndex] = conf.mapId(record);
            if (conf.class)
              this.tableValueMap['class-' + index + '_' + trueRecordIndex] = conf.class(record);
            if (conf.icon)
              this.tableValueMap['icon-' + index + '_' + trueRecordIndex] = conf.icon(record);
            if (conf.iconValue)
              this.tableValueMap['iconValue-' + index + '_' + trueRecordIndex] = conf.iconValue(record);
            if (conf.toolTip)
              this.tableValueMap['toolTip-' + index + '_' + trueRecordIndex] = conf.toolTip(record);
            if (conf.editable)
              this.tableValueMap['editable-' + index + '_' + trueRecordIndex] = conf.editable(record);
          }
        })
      }
    });
    super.reloadTableValueMap();
    if (this.subFormComponents)
      this.subFormComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
  }

  protected readonly AppComponent = AppComponent;

  onRowEditInit(record: any) {

  }

  onRowEditSave(record: any) {

  }

  onRowEditCancel(record: any, ri: any) {

  }

  recordChanged(record: any) {
    this.recordChange.emit(record);
    // if (fieldConfig.type === this.FieldTypes.MULTISELECT
    //   || fieldConfig.type === this.FieldTypes.DROPDOWN
    //   || fieldConfig.type === this.FieldTypes.LISTBOX
    //   || fieldConfig.type === this.FieldTypes.PICKLIST
    //   || fieldConfig.type === this.FieldTypes.INTEGER
    //   || fieldConfig.type === this.FieldTypes.DECIMAL
    // ) {
    //   this.formRecord[fieldConfig.field] = record.value;
    // } else if (fieldConfig.type === this.FieldTypes.SINGLERICHFIELD
    //   || fieldConfig.type === this.FieldTypes.RICHFIELD
    //   || fieldConfig.type === this.FieldTypes.ADDDELETEFIELD
    //   || fieldConfig.type === this.FieldTypes.TABLEFORMFIELD
    //   || fieldConfig.type === this.FieldTypes.MAPFIELD)
    //   this.formRecord[fieldConfig.field] = record;
    // if (fieldConfig.changed)
    //   fieldConfig.changed(record, this.formRecord);
    // this.reloadFieldValueMap();
    // this.recordChange.emit(this.record);
  }
}
